<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container px-0">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Pricing</h5>
                  </div>
                  <small class="text-truncate text-muted">table with detail</small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container px-0">

          <!-- Pricing: table -->
          <div class="row row-deck py-lg-5 py-2">

            <!-- Pricing: Basic -->
            <div class="col-sm-6 col-xl-3">
              <div class="card mb-3">
                <div class="flex-column align-items-start p-3">
                  <h3 class="font-weight-light mb-3">Basic</h3>
                  <span class="text-muted">Nemo enim ipsam voluptatem quia volup tas sit.</span>
                </div>
                <div class="card-header border-top d-flex justify-content-center align-items-end py-4">
                  <span>$</span>
                  <h2 class="mb-0 ms-2 me-2">39</h2>
                  <span class="text-muted">/month</span>
                </div>
                <ul class="list-group custom list-group-flush mb-0">
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>50GB</strong><span class="text-secondary ms-1">Storage</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>Unlimited</strong><span class="text-secondary ms-1">Bandwidth</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>1</strong><span class="text-secondary ms-1">Domain</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>Unlimited</strong><span class="text-secondary ms-1">Email accounts</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>1</strong><span class="text-secondary ms-1">Database</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>Unlimited</strong><span class="text-secondary ms-1">FTP accounts</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-close me-1 text-danger"></i>
                    <strong>No</strong><span class="text-secondary ms-1">Support</span>
                  </li>
                </ul>
                <div class="justify-content-center p-3">
                  <button class="btn btn-light btn-block">SUBSCRIBE PLAN</button>
                </div>
              </div>
            </div>

            <!-- Pricing: Standard -->
            <div class="col-sm-6 col-xl-3">
              <div class="card mb-3 shadow border-primary">
                <div class="flex-column align-items-start p-3">
                  <h3 class="font-weight-light mb-3">Standard</h3>
                  <span class="text-muted">Volup tatem quia volup tas sit asper natur aut odit aut.</span>
                </div>
                <div class="card-header border-top d-flex justify-content-center align-items-end py-4">
                  <span>$</span>
                  <h2 class="mb-0 ms-2 me-2">59</h2>
                  <span class="text-muted">/month</span>
                </div>
                <ul class="list-group custom list-group-flush border-bottom-0 mb-0">
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>100GB</strong><span class="text-secondary ms-1">Storage</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>Unlimited</strong><span class="text-secondary ms-1">Bandwidth</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>10</strong><span class="text-secondary ms-1">Domain</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>Unlimited</strong><span class="text-secondary ms-1">Email accounts</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>10</strong><span class="text-secondary ms-1">Database</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>Unlimited</strong><span class="text-secondary ms-1">FTP accounts</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>7x24</strong><span class="text-secondary ms-1">Support</span>
                  </li>
                </ul>
                <div class="justify-content-center p-3 border-top">
                  <button class="btn btn-primary btn-block">SUBSCRIBE PLAN</button>
                </div>
              </div>
            </div>

            <!-- Pricing: Premium -->
            <div class="col-sm-6 col-xl-3">
              <div class="card mb-3">
                <div class="flex-column align-items-start p-3">
                  <h3 class="font-weight-light mb-3">Premium</h3>
                  <span class="text-muted">Tas sit asper natur aut odit aut nemo enim ipsam volup.</span>
                </div>
                <div class="card-header border-top d-flex justify-content-center align-items-end py-4">
                  <span>$</span>
                  <h2 class="mb-0 ms-2 me-2">79</h2>
                  <span class="text-muted">/month</span>
                </div>
                <ul class="list-group custom list-group-flush mb-0">
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>200GB</strong><span class="text-secondary ms-1">Storage</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>Unlimited</strong><span class="text-secondary ms-1">Bandwidth</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>100</strong><span class="text-secondary ms-1">Domain</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>Unlimited</strong><span class="text-secondary ms-1">Email accounts</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>100</strong><span class="text-secondary ms-1">Database</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>Unlimited</strong><span class="text-secondary ms-1">FTP accounts</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>7x24</strong><span class="text-secondary ms-1">Support</span>
                  </li>
                </ul>
                <div class="justify-content-center p-3">
                  <button class="btn btn-light btn-block">SUBSCRIBE PLAN</button>
                </div>
              </div>
            </div>

            <!-- Pricing: Professional -->
            <div class="col-sm-6 col-xl-3">
              <div class="card mb-3">
                <div class="flex-column align-items-start p-3">
                  <h3 class="font-weight-light mb-3">Professional</h3>
                  <span class="text-muted">Volup tatem quia volup tas sit asper natur aut odit aut.</span>
                </div>
                <div class="card-header border-top d-flex justify-content-center align-items-end py-4">
                  <span>$</span>
                  <h2 class="mb-0 ms-2 me-2">99</h2>
                  <span class="text-muted">/month</span>
                </div>
                <ul class="list-group custom list-group-flush mb-0">
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>1TB</strong><span class="text-secondary ms-1">Storage</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>Unlimited</strong><span class="text-secondary ms-1">Bandwidth</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>Unlimited</strong><span class="text-secondary ms-1">Domain</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>Unlimited</strong><span class="text-secondary ms-1">Email accounts</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>Unlimited</strong><span class="text-secondary ms-1">Database</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>Unlimited</strong><span class="text-secondary ms-1">FTP accounts</span>
                  </li>
                  <li class="list-group-item py-2"><i class="zmdi zmdi-check me-1 text-success"></i>
                    <strong>7x24</strong><span class="text-secondary ms-1">Support</span>
                  </li>
                </ul>
                <div class="justify-content-center p-3">
                  <button class="btn btn-light btn-block">SUBSCRIBE PLAN</button>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
